import React from 'react'
import { MessageSquare } from 'lucide-react'

function EmptyConversationState() {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <div className="flex items-center justify-center w-20 h-20 mb-4 rounded-full bg-purple-100">
        <MessageSquare className="w-10 h-10 text-purple-600" />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-gray-900">No conversations yet</h3>
      <p className="text-sm text-gray-500 max-w-sm">Start a conversation to connect with coaches and guardians</p>
    </div>
  )
}

export default EmptyConversationState
